export default "/kiban/_next/static/images/hardGoldOnPCIEdgeTerminal-c99de862ed130779d993b17918ed79ca.png";